import { Trash2, FileArchive } from "lucide-react";
import { formatBytes } from "@/lib/api";

const HEADERS = ["Ścieżka", "Rozmiar", "SHA-256", "Zmieniono"];

const FileRow = ({ f, onRemove }) => (
  <tr className="border-t border-white/5 hover:bg-white/[0.02]" data-testid={`file-row-${f.path}`}>
    <td className="p-3 font-mono text-slate-200 flex items-center gap-2"><FileArchive size={14} className="text-amber-500/70" />{f.path}</td>
    <td className="p-3 font-mono text-slate-400">{formatBytes(f.size)}</td>
    <td className="p-3 font-mono text-xs text-amber-300/80" title={f.sha256} data-testid={`file-hash-${f.path}`}>{f.sha256?.slice(0, 16)}…</td>
    <td className="p-3 text-xs text-slate-500">{new Date(f.updated_at).toLocaleString("pl-PL")}</td>
    <td className="p-3 text-right">
      <button onClick={() => onRemove(f.path)} className="text-slate-500 hover:text-red-400 transition-colors" data-testid={`file-delete-${f.path}`}><Trash2 size={15} /></button>
    </td>
  </tr>
);

export default function FilesTable({ files, onRemove }) {
  return (
    <div className="rounded-lg border border-white/5 overflow-hidden">
      <table className="w-full text-sm" data-testid="files-table">
        <thead className="bg-[#11141c] text-[11px] tracking-widest text-slate-500">
          <tr>{HEADERS.map((h) => <th key={h} className="text-left p-3">{h}</th>)}<th /></tr>
        </thead>
        <tbody>
          {files.map((f) => <FileRow key={f.path} f={f} onRemove={onRemove} />)}
          {!files.length && <tr><td colSpan={5} className="p-8 text-center text-slate-600" data-testid="files-empty">Brak plików - wgraj pierwszy patch.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
